import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from './vuex/store'
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;
console.log('globo');
//a
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
